import axios from "axios";
import React, { useEffect, useState } from "react";
import { Check, X } from "react-feather";
import Modal from "react-modal";
import { useNavigate } from "react-router";
import { useAvaliacao } from "../../../Hooks/avaliado";
import { useCartorio } from "../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../Hooks/funcionarioCartorio";
import { useFuncionarioPrefeitura } from "../../../Hooks/funcionarioPrefeitura";
import { usePrefeitura } from "../../../Hooks/usePrefeitura";
import { IImovelFocus } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import api from "../../../Services/api";
import theme from "../../../Styles/theme";
import { app_base_url, base_url_unico_api } from "../../../Utils/baseUrl";
import { isRural } from "../../../Utils/isRural";
import { retiraVerificadores } from "../../../Utils/retiraVerificadores";
import { Alert } from "../../Error/Alert";
import { ModalDivX } from "../../ModalDivX";
import { ModalLoader } from "../../ModalLoader";
import { IAdquirinte } from "../Adquirinte";
import { ITransmitente } from "../Transmitente";
import {
  Button,
  Container,
  HelperButtons,
  Item,
  Lista,
  Span,
  Title,
} from "./styles";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  imovel: IImovelFocus;
 
}

export function ReenviarParaCartorio({
  open,
  onClose,
  imovel,

 
}: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  const { cartorioIsLogged, checarToken } = useCartorio();
  const { avaliado, createAvaliacao, updateAvaliacao } = useAvaliacao();
  const {
    prefeituraIsLogged,
    checarTokenPrefeitura,
    bancoPrefeitura,
    carregaLogo
  } = usePrefeitura();
  const {
    funcionarioPrefeituraIsLogged,
    checarTokenFuncionarioPrefeitura,
    FuncionarioPrefeitura,
  } = useFuncionarioPrefeitura();
  const navigate = useNavigate();

  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  async function execute() {
    try {
      if (cartorioIsLogged) {
        await checarToken();
      }

      if (funcionarioCartorioIsLogged) {
        await checarTokenFuncionario();
      }

      setLoading(true);

      //window.alert("ACHO Q INFORMOU")
      const { data } = await api.patch(
        `/imovel${isRural() ? "-rural" : ""}/reenviar-cartorio/${imovel.ID}`
      );

      setLoading(false);
      onClose();

      navigate(`${app_base_url}/imoveis${isRural() ? "-rural" : ""}`);
    } catch (error) {
      setError({
        message:
          "Não foi possível reenviar o imovel, tente novamente mais tarde!",
        title: "Ops",
      });
    } finally {
        setLoading(false);
    }
  }

  useEffect(() => {
    carregaLogo(imovel.PREFEITURA_ID)
  },[])

 
  useEffect(() => {
    if (funcionarioCartorioIsLogged) {
      checarTokenFuncionario();
    }
    if (cartorioIsLogged) {
      checarToken();
    }
    if (prefeituraIsLogged) {
      checarTokenPrefeitura();
    }
    if (funcionarioPrefeituraIsLogged) {
      checarTokenFuncionarioPrefeitura();
    }
  }, [open]);

  

  

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container>
        <Span>Tem certeza que deseja reenviar este imovel para o cartório?</Span>

        <Button onClick={() => onClose()}>
            CANCELAR
        </Button>

        <Button onClick={() =>execute()}>
            REENVIAR
        </Button>
      </Container>

      <ModalLoader loading={loading} />
      <Alert
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
        message={error.message}
        title={error.title}
      />
    </Modal>
  );
}
